"use client";
import DeliveryToAndLocation from "@/app/ec/product/[basePath]/deliveryToAndLocation";
import { useLocationDetails } from "@/app/hooks/useLocationDetails";
import { getCityAndZipcodeCookies } from "@/utils/locationDetails";
import { useEffect, useState } from "react";

export default function GetDeliveryLocationDetails({ hideBelowLg = false }: GetDeliveryLocationDetailsProps) {
  const { city, zipCode } = useLocationDetails();
  const [locationDetails, setLocationDetails] = useState({ city, zipCode });

  useEffect(() => {
    setLocationDetails({ city, zipCode });
  }, [city, zipCode]);

  const updateLocationDetails = () => {
    const { city, zipCode } = getCityAndZipcodeCookies();
    setLocationDetails({ city, zipCode });
  };

  return (
    <DeliveryToAndLocation
      hideBelowLg={hideBelowLg}
      deliveryToUser={locationDetails}
      updateLocationDetails={updateLocationDetails}
    />
  );
}

type GetDeliveryLocationDetailsProps = {
  hideBelowLg?: boolean;
};
